import type { ViewProps } from "./OverviewView";
import ReportTable from "../components/ReportTable";
import { pageColumns } from "../tableConfig";
export default function PagesView(props: ViewProps) {
  return (
    <ReportTable
      {...props}
      report="pages"
      title="Page performance"
      columns={pageColumns}
      details
    />
  );
}
